import template from './table-column.html';

export default {
  template,
  controller: 'TableColumnController',
  bindings: {
    column: '<',
    sortBy: '&'
  }
};


// WEBPACK FOOTER //
// ./src/modules/utils/grid/table-column-component.js